import { Button } from '@/swell-ui/Button'
import { Tooltip } from '@/swell-ui/Tooltip'
import { useSwellWeb3 } from '@/swell-web3/core'
import styled from 'styled-components'

export const StyledButtonThin = styled(Button)`
  width: 100%;
  height: unset;
  color: var(--white-50, #fff);
  /* Body/medium bold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%; /* 25.6px */
  padding: 8px 16px;
`

export function ConnectWalletButton() {
  const { connect } = useSwellWeb3()
  return (
    <StyledButtonThin onClick={() => connect()}>
      Connect Wallet
    </StyledButtonThin>
  )
}
const TooltipContainer = styled(Tooltip)`
  width: 100%;
`

export function ClaimWavedropButton({ tooltip }: { tooltip?: string }) {
  const btn = <StyledButtonThin disabled>Claim</StyledButtonThin>

  if (tooltip) {
    return <TooltipContainer title={tooltip}>{btn}</TooltipContainer>
  }

  return btn
}
